import Component from './component.vue';
import Props from './props';
import Script from './script';

export {
  Props,
  Script,
};
export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/card/index.ts